import { StaticDataItem } from '../../../../api/useAccountApi';
import ApplicantSection from './ApplicantSection';
import { useAccountContext } from '../../../../contexts';

export default function Applicants({
  countries,
  lendingRegions,
  ukCountries,
  accountancyQualifications,
  industries,
  jobTitles,
}: {
  countries: StaticDataItem[],
  lendingRegions: StaticDataItem[],
  ukCountries: StaticDataItem[],
  accountancyQualifications: StaticDataItem[],
  industries: StaticDataItem[],
  jobTitles: StaticDataItem[],
}) {
  const { account } = useAccountContext();
  const { applicants } = account;

  return (
    <>
      {applicants?.map((applicant, applicantIndex) => (
        <ApplicantSection
          key={applicant?.id}
          applicant={applicant}
          applicantIndex={applicantIndex}
          countries={countries}
          lendingRegions={lendingRegions}
          ukCountries={ukCountries}
          accountancyQualifications={accountancyQualifications}
          industries={industries}
          jobTitles={jobTitles}
          numberOfApplicants={applicants.length}
        />
      ))}
    </>
  );
}
